import React from "react";
import Modal from "react-bootstrap/Modal";

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      className="mail_modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-none"></Modal.Header>
      <Modal.Body>
        <span>Send Resume to</span>
        <p className="share_popup_email">justtrytechnologies@gmail.com</p>
      </Modal.Body>
    </Modal>
  );
}

export default MyVerticallyCenteredModal;
